<div class="ape-card">
  <div class="ape-accent" [style.background]="accent"></div>

  <div class="ape-header">
    <span class="ape-title">{{ title }}</span>
    <span class="ape-period">{{ period }}</span>
  </div>

  <div class="ape-body">
    <div class="ape-metric">
      <span class="ape-eyebrow">{{ valueLabel }}</span>
      <span class="ape-value">{{ value | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
    </div>
    <div class="ape-metric ape-metric-cases">
      <span class="ape-eyebrow">Cases</span>
      <span class="ape-cases">{{ cases | number }}</span>
    </div>
  </div>
</div>
